@for (component of components; track component) {
  <div>
    <ng-template #dynamic> </ng-template>
  </div>
}
